var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParkingError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uC8FC\\uCC28\\uAD00\\uC81C_\\uD1B5\\uC2E0\\uC0C1\\uD0DC_\\uBD88\\uB7C9",
    "data-name": "\\uC8FC\\uCC28\\uAD00\\uC81C_\\uD1B5\\uC2E0\\uC0C1\\uD0DC \\uBD88\\uB7C9",
    transform: "translate(-2618 11371)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8621",
    "data-name": "\\uC0AC\\uAC01\\uD615 8621",
    width: 32,
    height: 32,
    rx: 2,
    transform: "translate(2618 -11371)",
    fill: "rgba(45,52,72,0.6)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_8625",
    "data-name": "\\uC0AC\\uAC01\\uD615 8625",
    width: 24,
    height: 24,
    rx: 2,
    transform: "translate(2622 -11367)",
    fill: "#2d3448"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15324",
    "data-name": "\\uADF8\\uB8F9 15324",
    transform: "translate(-1.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "free-icon-wifi-3562383",
    transform: "translate(2625.649 -11364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6212",
    "data-name": "\\uD328\\uC2A4 6212",
    d: "M10.351,2a12.789,12.789,0,0,0-9.1,3.77.85.85,0,1,0,1.2,1.2,11.173,11.173,0,0,1,15.8,0,.85.85,0,1,0,1.2-1.2A12.789,12.789,0,0,0,10.351,2Z",
    transform: "translate(0 0)",
    fill: "#767b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6213",
    "data-name": "\\uD328\\uC2A4 6213",
    d: "M17.119,10.822a.85.85,0,0,0,0-1.2,8.866,8.866,0,0,0-12.537,0,.85.85,0,0,0,1.2,1.2,7.165,7.165,0,0,1,10.131,0,.85.85,0,0,0,1.2,0Z",
    transform: "translate(-0.5 -1.116)",
    fill: "#767b88"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6214",
    "data-name": "\\uD328\\uC2A4 6214",
    d: "M14.786,14.625a.85.85,0,0,0,0-1.2,4.857,4.857,0,0,0-6.87,0,.85.85,0,0,0,1.2,1.2,3.23,3.23,0,0,1,4.465,0,.85.85,0,0,0,1.2,0Z",
    transform: "translate(-0.999 -2.045)",
    fill: "#767b88"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1129",
    "data-name": "\\uD0C0\\uC6D0 1129",
    cx: 1.275,
    cy: 1.275,
    r: 1.275,
    transform: "translate(9.076 13.557)",
    fill: "#767b88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15326",
    "data-name": "\\uADF8\\uB8F9 15326",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_1127",
    "data-name": "\\uD0C0\\uC6D0 1127",
    cx: 4.5,
    cy: 4.5,
    r: 4.5,
    transform: "translate(2636 -11355)",
    fill: "#2d3448"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_15318",
    "data-name": "\\uADF8\\uB8F9 15318",
    transform: "translate(243 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6215",
    "data-name": "\\uD328\\uC2A4 6215",
    d: "M3.857,7.357a3.5,3.5,0,1,1,3.5-3.5,3.5,3.5,0,0,1-3.5,3.5Zm0-6.447A2.947,2.947,0,1,0,6.8,3.857,2.95,2.95,0,0,0,3.857.91Z",
    transform: "translate(2393.643 -11352.357)",
    fill: "#767b88",
    stroke: "#767b88",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_6216",
    "data-name": "\\uD328\\uC2A4 6216",
    d: "M17.571,30.046H14.065a.273.273,0,1,1,0-.546h3.506a.273.273,0,1,1,0,.546Z",
    transform: "translate(2381.682 -11378.272)",
    fill: "#767b88",
    stroke: "#767b88",
    strokeWidth: 0.3
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParkingError);
export default __webpack_public_path__ + "static/media/parking_error.305295b09966d3c81d50acba4b6885de.svg";
export { ForwardRef as ReactComponent };